import { Alert, Platform } from "react-native";

type AlertStyle = "default" | "cancel" | "destructive";
type AlertButton = { text: string; onPress?: () => void; style?: AlertStyle };

type ConfirmAlertParams = {
  title: string;
  body: string;
  cancelButton: AlertButton;
  confirmButton: AlertButton;
};
export function confirmAlert({
  title,
  body,
  cancelButton,
  confirmButton,
}: ConfirmAlertParams) {
  if (Platform.OS === "web") {
    // firefox complains about this kind of alert/confirm sometimes, so we wrap in timeout
    // https://github.com/facebook/react/issues/17355#issuecomment-871805975
    setTimeout(() => {
      if (confirm(`${title}\n\n${body}`)) {
        confirmButton.onPress?.();
      } else {
        cancelButton.onPress?.();
      }
    });
  } else {
    Alert.alert(title, body, [
      { style: "cancel", ...cancelButton },
      confirmButton,
    ]);
  }
}

type UnsavedChangesAlertParams = { isDirty: boolean; goBack: () => void };
export function unsavedChangesAlert({
  isDirty,
  goBack,
}: UnsavedChangesAlertParams) {
  if (isDirty) {
    confirmAlert({
      title: "Tienes cambios sin guardar",
      body: "¿Deseas salir de esta pantalla y perder los cambios?",
      cancelButton: { text: "Cancelar" },
      confirmButton: { text: "Salir", style: "destructive", onPress: goBack },
    });
  } else {
    goBack();
  }
}
